module.exports = __webpack_public_path__ + "img/mt4-icon2.40b83a6.png";